import axios from "./Constant.js";

export const mobile_login = async (data) => {
  try {
    const response = await axios.post("/login", data);
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

//WPPFT
export const insertWppft = async (token, data) => {
  try {
    const response = await axios.post("/insert_wppft", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const getWppftDetails = async (token, data) => {
  try {
    const response = await axios.post("/get_wppft_details", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const deleteWppftDetails = async (token, id) => {
  try {
    const response = await axios.post(
      "/delete_wppft_details",
      { id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const updateWppft = async (token, formData) => {
  try {
    const response = await axios.post("/update_wppft", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

// GPPFT
export const insertGppft = async (token, data) => {
  try {
    const response = await axios.post("/insert_gppft", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const getGppftDetails = async (token, data) => {
  try {
    const response = await axios.post("/get_gppft_details", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const deleteGppftDetails = async (token, id) => {
  try {
    const response = await axios.post(
      "/delete_gppft_details",
      { id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const updateGppft = async (token, formData) => {
  try {
    const response = await axios.post("/update_gppft", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

//Frontline as Resource Person
export const insertOfficersDetails = async (token, data) => {
  try {
    const response = await axios.post("/insert_officers_details", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const getOfficersDetails = async (token, data) => {
  try {
    const response = await axios.post("/get_officers_details", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const deleteOfficersDetails = async (token, id) => {
  try {
    const response = await axios.post(
      "/delete_officers_details",
      { id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const updateOfficersDetails = async (token, formData) => {
  try {
    const response = await axios.post("/update_officers_details", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

//Facilator as Resource Person
export const insertResourcesTable = async (token, data) => {
  try {
    const response = await axios.post("/insert_resources_table", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const getResourcesDetails = async (token, data) => {
  try {
    const response = await axios.post("/get_resources_details", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const deleteResourcesDetails = async (token, id) => {
  try {
    const response = await axios.post(
      "/delete_resources_details",
      { id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const updateResourcesTable = async (token, formData) => {
  try {
    const response = await axios.post("/update_resources_table", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
//commitee member
export const add_new_committe_member = async (token, formData) => {
  try {
    // Log formData to verify the structure
    console.log("FormData being sent to API:", formData);

    const response = await axios.post("/add_new_committe_member", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const get_committee_members_data = async (token, data) => {
  try {
    const response = await axios.post("/get_committee_members_data", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const disableCommitteMember = async (token, data) => {
  try {
    const response = await axios.post("/disable_committe_member", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const deleteCommitteMember = async (token, id) => {
  try {
    const response = await axios.post(
      "/delete_committe_member",
      { id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const updateCommitteTable = async (token, editData) => {
  try {
    const response = await axios.post("/update_committe_member", editData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

// Dropdown Admin Screen

// export const getVillageByBlock = async (token, block_code) => {
//   try {
//     const response = await axios.post("/get_village_by_block", block_code, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     });
//     return response.data;
//   } catch (error) {
//     console.error("Error - ", error);
//     throw error;
//   }
// };

export const disableGpftDetails = async (token, data) => {
  try {
    const response = await axios.post("/disable_gppft_details", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const disableWpftDetails = async (token, data) => {
  try {
    const response = await axios.post("/disable_wppft_details", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const disableOfficersDetails = async (token, data) => {
  try {
    const response = await axios.post("/disable_officers_details", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const disableResourcesDetails = async (token, data) => {
  try {
    const response = await axios.post("/disable_resources_details", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const dataFromLgd = async (token, data) => {
  try {
    const response = await axios.post("/get_data_from_lgd_code", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const logout = async () => {
  try {
    const response = await axios.post("/logout");
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
//entity type
export const get_entity_type = async (token) => {
  try {
    const response = await axios.get("/get_entity_type", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
//district
export const getDistrict = async (token, userId, role_id) => {
  try {
    const response = await axios.get("/get_district", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        user_id: userId,
        role_id: role_id,
        _t: Date.now(),
      }
    });

    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

//village or gram panchayat
export const getVillageByBlock = async (token, district_code, block_code, userId, role_id) => {
  try {
    const response = await axios.post(
      "/get_village_by_block",
      { district_code, block_code }, // body
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          user_id: userId,
          role_id: role_id,
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching villages:", error);
    throw error;
  }
};

//block
export const getBlockByDistrict = async (token, district_code, userId, role_id) => {
  try {
    const response = await axios.post(
      "/get_block_by_district",
      { district_code }, // body
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          user_id: userId,
          role_id: role_id,
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const show_resource_detail = async (token, data) => {
  try {
    const response = await axios.post("/show_resource_detail", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const getSacivDetails = async (token, user_id) => {
  try {
    const response = await axios.post(
      "show_gram_sachiv_details",
      { user_id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const updateSachivDetails = async (token, data) => {
  return await axios
    .post("/update_gram_sachiv", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
};
export const getSarpanchDetails = async (token, user_id) => {
  try {
    const response = await axios.post(
      "show_sarpanch_details",
      { user_id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const add_new_mahila_sabha_member = async (token, data) => {
  try {
    const response = await axios.post("/add_new_mahila_sabha_member", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const get_mahila_sabha_members_data = async (token, data) => {
  try {
    const response = await axios.post("/get_mahila_sabha_members_data", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const delete_mahila_bal_sabha_member = async (token, id) => {
  try {
    const response = await axios.post(
      "/delete_mahila_bal_sabha_member",
      id,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const update_mahila_bal_sabha_member = async (token, formData) => {
  try {
    const response = await axios.post(
      "/update_mahila_bal_sabha_member",
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
//Bal Sabha

export const add_new_bal_sabha_member = async (token, data) => {
  try {
    const response = await axios.post("/add_new_bal_sabha_member", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const get_bal_sabha_members_data = async (token, data) => {
  try {
    const response = await axios.post("/get_bal_sabha_members_data", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const disable_mahila_bal_sabha_member = async (token, data) => {
  try {
    const response = await axios.post(
      "/disable_mahila_bal_sabha_member",
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const getOtherDetails = async (token, user_id) => {
  try {
    const response = await axios.post(
      "/show_profile_other_details",
      { user_id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const get_gppft_freeze_details = async (token, data) => {
  try {
    const response = await axios.post("get_gppft_freeze_details", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const updateSarpanchDetails = async (token, data) => {
  return await axios
    .post("/update_sarpanch", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
};
export const updateOtherDetails = async (token, data) => {
  return await axios
    .post("/update_profile_other_details", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
};



// Meeting API's
export const schedule_meeting_api = async (token, formDataToSend) => {
  try {
    const response = await axios.post('schedule_meeting_api', formDataToSend, {
      headers: {
        'Authorization': `Bearer ${token}` // Authorization header if required
      },
    });
    return response.data;
  } catch (error) {
    console.error('API error:', error.response ? error.response.data : error.message);
    throw error;
  }
};
// all freeze member
export const freeze_members = async (token, data) => {
  try {
    const response = await axios.post("/freeze_members", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
//get freeze wppft
export const get_wppft__freeze_details = async (token, data) => {
  try {
    const response = await axios.post("get_wppft__freeze_details", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const getMOMDetails = async (token, data, page = 1, limit = 10, period = undefined) => {
  try {
    let url = `/show_data_for_mom?page=${page}&limit=${limit}`;

    // Add period parameter if provided
    if (period) {
      url += `&period=${period}`;
    }

    const response = await axios.post(
      url,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const updateDataForMom = async (token, data) => {
  try {
    const response = await axios.patch(
      "/update_data_for_mom",
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const uploadMOM = async (token, data) => {
  return await axios
    .post("/upload_mom", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
};
//Resources freeze Details
export const get_resources__freeze_details = async (token, data) => {
  try {
    const response = await axios.post("get_resources__freeze_details", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
//Officer freeze Details
export const get_officers__freeze_details = async (token, data) => {
  try {
    const response = await axios.post("get_officers__freeze_details", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
//get committee mahila bal freeze data
//Bal Sabha Freeze Details
export const get_committee_mahila_bal_freeze_data = async (token, data) => {
  try {
    const response = await axios.post("get_committee_mahila_bal_freeze_data", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};
export const ward_sabha_check = async (token, data) => {
  try {
    const response = await axios.post("ward_sabha_check", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

// export const show_meeting_data = async (token, data, page = 1, limit = 10) => {
export const show_meeting_data = async (token, data, page = 1, limit = 10, period = null) => {
  try {
    const response = await axios.post(
      "show_meeting_data",
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          page,
          limit,
          ...(period && { period })
        },
      }
    );



    return response.data;
  } catch (error) {
    console.error("show_meeting_data Error - ", error);
    console.error("show_meeting_data Error - ", error);
    throw error;
  }
};




// Function to call the API and get the committee names
export const show_committee_names = async (token) => {
  try {
    // Make the GET request to the backend
    const response = await axios.get("/show_committee_names", {
      headers: {
        Authorization: `Bearer ${token}`,  // Passing the token in headers
      },
    });

    // Return the response data
    return response.data;
  } catch (error) {
    // Handle errors appropriately
    if (error.response) {
      // Server response error
      console.error("Server Error - ", error.response.data);
    } else if (error.request) {
      // Network error
      console.error("Network Error - ", error.request);
    } else {
      // Other errors
      console.error("Error - ", error.message);
    }
    throw error;  // Rethrow error so the caller can handle it
  }
};

export const show_sustanaible_goals = async (token, committee_id) => {
  try {
    const response = await axios.post(
      "/show_sustanaible_goals",
      { committee_id },  // Send the committee_id in the request body
      {
        headers: {
          Authorization: `Bearer ${token}`,  // Correct syntax for template literals
        },
      }
    );

    // Return the response data
    return response.data;
  } catch (error) {
    console.error("Error -", error);
    throw error;  // Rethrow the error so it can be handled by the caller
  }
};
export const getAllGramPanchayat = async (token, user_id) => {
  try {
    const response = await axios.post(
      "/get_gram_panchayat_for_gs",
      { user_id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};

export const get_meeting_transcript = async (token, data) => {
  try {
    const response = await axios.post("get_transcript_details", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error - ", error);
    throw error;
  }
};


export const getFamilyIncome = async (token, opts = {}) => {
  try {
    const page = opts.page || 1;
    const pageSize = opts.pageSize || 10;

    const params = {
      limit: pageSize,
      offset: (page - 1) * pageSize,
      role_id: opts.role_id,
      gp_data: opts.gp_data,
    };

    const config = {
      params,
      headers: {}
    };

    if (token) config.headers.Authorization = `Bearer ${token}`;
    if (opts.withCredentials) config.withCredentials = true;

    // VERY IMPORTANT FIX — only this URL works
    const res = await axios.get("/get_family_income", config);

    return res.data;

  } catch (err) {
    if (err.response && err.response.data) throw err.response.data;
    throw { status: "error", message: err.message || "Network error" };
  }
};
// getFamilyMembersByHead — uses path param member_ppp_id
export const getFamilyMembersByHead = async (token, member_ppp_id) => {
  if (!member_ppp_id) {
    throw { status: false, message: "member_ppp_id is required" };
  }

  const config = {
    headers: {}
  };
  if (token) config.headers.Authorization = `Bearer ${token}`;

  try {
    // NOTE: backend expects path param: /get_family_member/:member_ppp_id
    const response = await axios.get(`/get_family_member/${encodeURIComponent(member_ppp_id)}`, config);
    return response.data;
  } catch (error) {
    console.error("getFamilyMembersByHead Error - ", error.response ? error.response.data : error.message);
    // Re-throw so caller can handle
    throw error.response?.data || { status: false, message: error.message || "Network error" };
  }
};

// In your API file (../api/User.js)
export const updateFamilyMemberIncome = async (token, user_id, member_ppp_id, updated_income, is_approved_by_gs = "No", id = null) => {
  try {
    if (!member_ppp_id) {
      return { status: false, message: "member_ppp_id is required" };
    }

    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    const payload = {
      user_id,
      records: [
        {
          id: id || member_ppp_id, // Use provided id or fallback to member_ppp_id
          member_ppp_id: member_ppp_id,
          updated_income: updated_income || "0",
          is_approved_by_gs: is_approved_by_gs || "No"
        }
      ]
    };

    console.log('Making API call to:', `update_family_member_income/${member_ppp_id}`);
    console.log('Payload:', payload);

    const res = await axios.put(`update_family_member_income/${member_ppp_id}`, payload, {
      headers,
    });

    console.log('API Response:', res.data);

    if (res && res.data) {
      return res.data;
    }

    return { status: false, message: "No response from server" };
  } catch (err) {
    console.error("updateFamilyMemberIncome Error - ", err);
    console.error("Error details:", err.response?.status, err.response?.data);

    if (err?.response && err.response.data) throw err.response.data;
    throw { status: false, message: err.message || "Network error" };
  }
};
// Bulk update function that calls the single update endpoint multiple times
export const updateFamilyMemberIncomeBulk = async (token, user_id, records) => {
  try {
    if (!Array.isArray(records) || records.length === 0) {
      return { status: false, message: "records array is required" };
    }

    console.log('Starting bulk update for', records.length, 'records');

    const results = [];

    for (const record of records) {
      try {
        console.log(`Processing record:`, record);

        // Call the single update endpoint for each member
        const result = await updateFamilyMemberIncome(
          token,
          user_id,
          record.member_ppp_id,
          record.updated_income,
          record.is_approved_by_gs,
          record.id
        );

        results.push({
          success: true,
          member_ppp_id: record.member_ppp_id,
          data: result
        });

      } catch (error) {
        console.error(`Failed to update ${record.member_ppp_id}:`, error);
        results.push({
          success: false,
          member_ppp_id: record.member_ppp_id,
          error: error.message || "Update failed"
        });
      }

      // Small delay between requests to avoid overwhelming the server
      await new Promise(resolve => setTimeout(resolve, 100));
    }

    const successCount = results.filter(r => r.success).length;
    const failedCount = results.filter(r => !r.success).length;

    return {
      status: successCount > 0,
      message: `Processed ${records.length} records: ${successCount} succeeded, ${failedCount} failed`,
      total_records: records.length,
      updated_count: successCount,
      failed_count: failedCount,
      results: results
    };

  } catch (err) {
    console.error("updateFamilyMemberIncomeBulk Error:", err);
    throw { status: false, message: err.message || "Network error" };
  }
};

export const getFamilyMembersByFamilyPPP = async (token, family_ppp_id) => {
  if (!family_ppp_id) {
    throw { status: false, message: "family_ppp_id is required" };
  }

  const config = {
    params: { family_ppp_id },
    headers: {}
  };
  if (token) config.headers.Authorization = `Bearer ${token}`;

  try {
    // backend expects: GET /get_family_member?family_ppp_id=9ORX6946
    const response = await axios.get("/get_family_member", config);
    return response.data;
  } catch (error) {
    console.error("getFamilyMembersByFamilyPPP Error - ", error.response ? error.response.data : error.message);
    throw error.response?.data || { status: false, message: error.message || "Network error" };
  }
};

export const getVillageByGP = async (token, gram_panchayat_code) => {
  if (!gram_panchayat_code) {
    throw { status: false, message: "gram_panchayat_code is required" };
  }

  const config = {
    params: { gram_panchayat_code },
    headers: {},
  };
  if (token) config.headers.Authorization = `Bearer ${token}`;

  try {
    const response = await axios.get("/get_village", config);
    // expected { status: "success", data: [...], length: ... } from backend
    return response.data;
  } catch (error) {
    console.error("getVillageByGP Error - ", error.response ? error.response.data : error.message);
    throw error.response?.data || { status: false, message: error.message || "Network error" };
  }
};







export const downloadMomDoc = async (token, meeting_id, file_path, file_type) => {
  /* ================= VALIDATIONS ================= */
  if (!meeting_id) {
    throw { status: false, message: "meeting_id is required" };
  }

  if (!file_path) {
    throw { status: false, message: "file_path is required" };
  }

  /* ================= FIX FILE PATH ================= */
  // Case 1: file_path is array → take first value
  if (Array.isArray(file_path)) {
    file_path = file_path[0];
  }

  // Case 2: file_path is stringified array → parse & take first value
  if (typeof file_path === "string" && file_path.startsWith("[")) {
    try {
      const parsedPath = JSON.parse(file_path);
      if (Array.isArray(parsedPath)) {
        file_path = parsedPath[0];
      }
    } catch (err) {
      console.error("Invalid file_path format", err);
    }
  }

  /* ================= AXIOS CONFIG ================= */
  const config = {
    responseType: "blob",
    headers: {},
  };

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  /* ================= API CALL ================= */
  try {
    const response = await axios.post(
      "/download_mom_doc",
      {
        meeting_id,
        file_path, // ✅ CLEAN STRING (NO [])
        file_type,
      },
      config
    );

    return response; // blob response
  } catch (error) {
    console.error(
      "downloadMomDoc Error - ",
      error.response ? error.response.data : error.message
    );

    throw (
      error.response?.data || {
        status: false,
        message: error.message || "Network error",
      }
    );
  }
};

export const getReportData = async (token, period = null) => {
  try {
    const response = await axios.get("/get_report_data", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: period ? { period } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching report data:", error);
    throw error;
  }
};



// Forgot Password - Step 1: Send OTP
export const forgotPassword = async (mobile) => {
  try {
    const response = await axios.post("/send-otp", { mobile });
    return response.data;
  } catch (error) {
    console.error("Forgot Password Error - ", error);
    throw error;
  }
};

// Forgot Password - Step 2: Verify OTP
export const verifyOtp = async (mobile, otp, role_id) => {
  try {
    const response = await axios.post("/verify-otp", {
      mobile,
      otp,
      role: role_id // Sending as 'role' to match backend
    });
    return response.data;
  } catch (error) {
    console.error("Verify OTP Error - ", error);
    throw error;
  }
};
// Forgot Password - Step 3: Reset Password
export const resetPassword = async (mobile, newPassword, otp) => {
  try {
    const response = await axios.post("/reset-password", {
      mobile,
      newPassword,
      otp
    });
    return response.data;
  } catch (error) {
    console.error("Reset Password Error - ", error);
    throw error;
  }
};

// Update schedule meeting details
// In User.js - Add this function
// Update schedule meeting details - Match backend requirements
export const updateScheduleMeetingDetails = async (token, data) => {
  try {
    console.log("Sending update request with data:", data);

    // The backend expects user_id, not userId
    const formattedData = {
      ...data,
      user_id: data.userId, // Map userId to user_id
      // Remove userId field as backend expects user_id
    };

    // Remove userId if we don't want duplicate
    if (formattedData.userId) {
      delete formattedData.userId;
    }

    console.log("Formatted data for backend:", formattedData);

    const response = await axios.patch("/update_schedule_meeting_details", formattedData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
    });

    console.log("Update response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Full error details:", error);

    if (error.response && error.response.data) {
      console.error("Server error response:", error.response.data);

      const serverError = error.response.data;
      const errorMessage = serverError.message ||
        serverError.error ||
        `Server error: ${error.response.status}`;

      throw new Error(errorMessage);
    }

    throw error;
  }
};



// In ../api/User.js - Update this function:
// In ../api/User.js - Update this function:
export const getFamilyMembersWithSchemes = async (token, params = {}) => {
  try {
    const { limit = 200, offset = 0 } = params;

    const response = await axios.get("/get_family_members_with_schemes", {
      params: { limit, offset },
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching family members with schemes:", error);
    throw error.response?.data || { status: false, message: error.message };
  }
};



// NEW API — Show meeting data for Gram Sabha Report
// ================== GRAM SABHA REPORT (ALL PANCHAYATS) ==================
// src/api/User.js
export const getGramSabhaReportAll = async (token, page, limit, period = null) => {
  try {
    const response = await axios.get("/show_meeting_data_for_village", {
      params: {
        page,
        limit,
        ...(period && { period }),
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("getGramSabhaReportAll Error:", error);
    throw error.response?.data || error;
  }
};


// ✓ Get Scheme / Income Summary – Panchayat Wise
export const getSchemeReport = async (token, payload) => {
  try {
    const response = await axios.get(
      "/family-income-summary-by-panchayat",
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: payload,
      }
    );

    return response.data;
  } catch (error) {
    console.error("getSchemeReport Error:", error);
    throw error.response?.data || error;
  }
}

// ✓ Get Scheme Verification Report - Drill down summary
export const getSchemeVerificationReport = async (token, payload) => {
  try {
    const response = await axios.get(
      "/get_scheme_verification_report",
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          ...payload,
          _t: Date.now(),
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("getSchemeVerificationReport Error:", error);
    throw error.response?.data || error;
  }
}

// ✓ Get Income Verification Report - Drill down summary
export const getIncomeVerificationReport = async (token, payload) => {
  try {
    const response = await axios.get(
      "/get_income_verification_report",
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          ...payload,
          _t: Date.now(),
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("getIncomeVerificationReport Error:", error);
    throw error.response?.data || error;
  }
}


// ================== HOF INCOME VERIFICATION APIs ==================

/**
 * Insert HOF Income Verification Records
 * @param {string} token - Auth token
 * @param {Array} records - Array of verification records
 * @param {number} user_id - User ID
 */
export const insertHofIncomeVerification = async (token, records, user_id) => {
  try {
    if (!Array.isArray(records) || records.length === 0) {
      throw { status: false, message: "records array is required" };
    }

    const response = await axios.post(
      "/insert_hof_income_verification",
      { records, user_id },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    return response.data;
  } catch (error) {
    console.error("insertHofIncomeVerification Error:", error);
    throw error.response?.data || { status: false, message: error.message };
  }
};

/**
 * Update HOF Income Verification Record (one-time edit)
 * @param {string} token - Auth token
 * @param {number} hofiv_id - Verification record ID
 * @param {string} gs_hof_income_veri - Verification status (Yes/No)
 * @param {string} gs_hof_income_veri_remark - Remark
 * @param {number} user_id - User ID
 */
export const updateHofIncomeVerification = async (token, hofiv_id, gs_hof_income_veri, gs_hof_income_veri_remark, user_id) => {
  try {
    if (!hofiv_id) {
      throw { status: false, message: "hofiv_id is required" };
    }

    const response = await axios.put(
      "/update_hof_income_verification",
      {
        hofiv_id,
        gs_hof_income_veri,
        gs_hof_income_veri_remark,
        user_id,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    return response.data;
  } catch (error) {
    console.error("updateHofIncomeVerification Error:", error);
    throw error.response?.data || { status: false, message: error.message };
  }
};


// ================== SPECIAL GRAM SABHA STATUS API ==================
export const getSpecialGramSabhaStatus = async (token, payload) => {
  try {
    const response = await axios.get(
      "/get_special_gram_sabha_status", // ✅ correct route
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: payload, // 🔥 cleaner
      }
    );

    return response.data;
  } catch (error) {
    console.error("getSpecialGramSabhaStatus Error:", error);
    throw error.response?.data || error;
  }
};




// ===== VOTER COUNT APIs =====
export const getVoterCount = async (token, data) => {
  try {
    const response = await axios.post(
      "/get_voter_count",
      data, // 👈 goes to req.body
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("getVoterCount Error - ", error);
    throw error;
  }
};

export const updateVoterCount = async (token, data) => {
  try {
    const response = await axios.put("/update_voter_count", data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("updateVoterCount Error - ", error);
    throw error;
  }
};



export const updateGpVoterCount = async (token, data) => {
  const res = await axios.put(
    "/update_gp_voter_count",
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return res.data;
};


// ================= Development Work Summary APIs =================

// CREATE
export const createDevelopmentWorkSummary = async (data) => {
  const token = sessionStorage.getItem("token");

  const res = await axios.post(
    "/create_development_work_summary",
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return res.data;
};


export const getAllDevelopmentWorkSummary = async ({
  page = 1,
  limit = 10,
  panchayat_code,
  sched_meet_id,
  meeting_id,
}) => {
  const token = sessionStorage.getItem("token");

  if (!panchayat_code) {
    throw new Error("panchayat_code is required");
  }

  const params = {
    page,
    limit,
    panchayat_code,
  };

  const mId = sched_meet_id || meeting_id;
  if (mId) {
    params.sched_meet_id = mId;
    params.meeting_id = mId;
  }

  const res = await axios.get(
    "/get_all_development_work_summary",
    {
      params,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return res.data;
};


export const updateDevelopmentWorkSummary = async (data) => {
  const token = sessionStorage.getItem("token");

  const res = await axios.patch(
    "/update_development_work_summary",
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return res.data;
};


export const deleteDevelopmentWorkSummary = async (id) => {
  const token = sessionStorage.getItem("token");

  const res = await axios.delete(
    "/delete_development_work_summary",
    {
      params: { id },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return res.data;
};




// ================= AMRIT SAROVAR APIs =================

// CREATE
export const createSarovarDetails = async (data) => {
  const token = sessionStorage.getItem("token");

  const res = await axios.post(
    "/create_sarovar_details",
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return res.data;
};

// GET ALL
export const getAllSarovarDetails = async (page = 1, limit = 10) => {
  const token = sessionStorage.getItem("token");

  const res = await axios.get(
    "/get_all_sarovar_details",
    {
      params: { page, limit },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return res.data;
};

// UPDATE
export const updateSarovarDetails = async (data) => {
  const token = sessionStorage.getItem("token");

  const res = await axios.patch(
    "/update_sarovar_details",
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return res.data;
};

// DELETE
export const deleteSarovarDetails = async (id) => {
  const token = sessionStorage.getItem("token");

  const res = await axios.delete(
    "/delete_sarovar_details",
    {
      data: { id },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return res.data;
};

// Add this function after your other API functions
const checkExistingMeeting = async (token, data) => {
  try {
    const response = await fetch("your-api-base-url/check_existing_meeting", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.error("Error checking existing meeting:", error);
    return { status: "error", message: "Failed to check existing meeting" };
  }
};


// ================= MEETING DATES API =================
export const getAllMeetingDates = async (token, filters, period = null) => {
  try {
    const response = await axios.get(
      "/get_all_meeting_dates",
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          ...filters,
          ...(period && { period })
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("getAllMeetingDates Error - ", error);
    throw error.response?.data || {
      status: false,
      message: error.message || "Network error"
    };
  }
};


export const getBdpoReportCeo = async (token, filters) => {
  try {
    const user_id = sessionStorage.getItem("user_id");
    const response = await axios.get(
      "/get_bdpo_block_report-ceo",
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          ...filters,
          user_id: user_id,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("getBdpoReportCeo Error - ", error);
    throw error.response?.data || {
      status: false,
      message: error.message || "Network error"
    };
  }
};

export const getBdpoReportBdpo = async (token, filters) => {
  try {
    const user_id = sessionStorage.getItem("user_id");
    const response = await axios.get(
      "/get_bdpo_block_report-bdpo",
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          ...filters,
          user_id: user_id,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("getBdpoReportBdpo Error - ", error);
    throw error.response?.data || {
      status: false,
      message: error.message || "Network error"
    };
  }
};

export const getPanchayatReportSachiv = async (token, filters) => {
  try {
    const user_id = sessionStorage.getItem("user_id");
    const response = await axios.get(
      "/get_panchayat_report-sachiv",
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          ...filters,
          user_id: user_id,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("getPanchayatReportSachiv Error - ", error);
    throw error.response?.data || {
      status: false,
      message: error.message || "Network error"
    };
  }
};

export const getPanchayatReportBdpo = async (token, filters) => {
  try {
    const user_id = sessionStorage.getItem("user_id");
    const response = await axios.get(
      "/get_panchayat_report-bdpo",
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          ...filters,
          user_id: user_id,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("getPanchayatReportBdpo Error - ", error);
    throw error.response?.data || {
      status: false,
      message: error.message || "Network error"
    };
  }
};



export const getBdpoGpReport = async (token, block_code) => {
  try {
    const user_id = sessionStorage.getItem("user_id");
    const response = await axios.post(
      "/get_bdpo_gp_report",
      {
        block_code: block_code,
        user_id: user_id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("getBdpoGpReport Error - ", error);
    throw error.response?.data || {
      status: false,
      message: error.message || "Network error"
    };
  }
};


export const getCeoBlockReport = async (token, district_code) => {
  try {
    const user_id = sessionStorage.getItem("user_id");
    const response = await axios.get(
      "/get_ceo_block_report",
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          district_code: district_code,
          user_id: user_id,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("getCeoBlockReport Error - ", error);
    throw error.response?.data || {
      status: false,
      message: error.message || "Network error"
    };
  }
};

export const getCeoGpReport = async (token, district_code) => {
  try {
    const user_id = sessionStorage.getItem("user_id");
    const response = await axios.post(
      "/get_ceo_gp_report",
      {
        district_code: district_code,
        user_id: user_id,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("getCeoGpReport Error - ", error);
    throw error.response?.data || {
      status: false,
      message: error.message || "Network error"
    };
  }
};

/* =====================================================
   ADMIN REPORT APIs (No user_id filtering)
===================================================== */

export const getAdminDistrictReport = async (token, period = null) => {
  try {
    const response = await axios.get(
      "/get_admin_district_report",
      {
        params: period ? { period } : {},
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("getAdminDistrictReport Error - ", error);
    throw error.response?.data || {
      status: false,
      message: error.message || "Network error"
    };
  }
};

export const getAdminBlockReport = async (token, district_code, period = null) => {
  try {
    const response = await axios.get(
      "/get_admin_block_report",
      {
        params: {
          district_code: district_code,
          ...(period && { period }),
        },
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("getAdminBlockReport Error - ", error);
    throw error.response?.data || {
      status: false,
      message: error.message || "Network error"
    };
  }
};

export const getAdminGpReport = async (token, district_code, period = null) => {
  try {

    const response = await axios.post(
      "/get_admin_gp_report",
      {
        district_code: district_code,
        period: period || undefined,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("getAdminGpReport Error - ", error);
    throw error.response?.data || {
      status: false,
      message: error.message || "Network error"
    };
  }
};


// ==================== SIGNED URL APIs ====================

/**
 * Generate a signed URL for a single S3 file
 * @param {string} token - Authentication token
 * @param {string} fileUrl - S3 file URL
 * @param {number} expiresIn - Expiration time in seconds (default: 3600 = 1 hour)
 * @returns {Promise} Response with signed URL
 */
export const generateSignedUrl = async (token, fileUrl, expiresIn = 3600) => {
  try {
    const response = await axios.post(
      "/generate_signed_url",
      {
        file_url: fileUrl,
        expires_in: expiresIn,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("generateSignedUrl Error - ", error);
    throw error.response?.data || {
      status: "error",
      message: error.message || "Failed to generate signed URL",
    };
  }
};

/**
 * Generate signed URLs for multiple S3 files
 * @param {string} token - Authentication token
 * @param {Array<string>} fileUrls - Array of S3 file URLs
 * @param {number} expiresIn - Expiration time in seconds (default: 3600 = 1 hour)
 * @returns {Promise} Response with signed URLs
 */
export const generateMultipleSignedUrls = async (token, fileUrls, expiresIn = 3600) => {
  try {
    const response = await axios.post(
      "/generate_multiple_signed_urls",
      {
        file_urls: fileUrls,
        expires_in: expiresIn,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("generateMultipleSignedUrls Error - ", error);
    throw error.response?.data || {
      status: "error",
      message: error.message || "Failed to generate signed URLs",
    };
  }
};

/**
 * Generate signed URL with content disposition (for viewing inline or downloading)
 * @param {string} token - Authentication token
 * @param {string} fileUrl - S3 file URL
 * @param {string} disposition - 'inline' for viewing, 'attachment' for downloading
 * @param {number} expiresIn - Expiration time in seconds (default: 3600 = 1 hour)
 * @returns {Promise} Response with signed URL
 */
export const generateSignedUrlWithDisposition = async (
  token,
  fileUrl,
  disposition = "inline",
  expiresIn = 3600
) => {
  try {
    const response = await axios.post(
      "/generate_signed_url_with_disposition",
      {
        file_url: fileUrl,
        disposition: disposition,
        expires_in: expiresIn,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("generateSignedUrlWithDisposition Error - ", error);
    throw error.response?.data || {
      status: "error",
      message: error.message || "Failed to generate signed URL",
    };
  }
};

/**
 * Helper function to view file in new tab using signed URL
 * @param {string} token - Authentication token
 * @param {string} fileUrl - S3 file URL
 * @param {number} expiresIn - Expiration time in seconds
 */
export const viewFileInNewTab = async (token, fileUrl, expiresIn = 3600) => {
  try {
    const response = await generateSignedUrlWithDisposition(
      token,
      fileUrl,
      "inline",
      expiresIn
    );

    if (response.status === "success" && response.data.signed_url) {
      window.open(response.data.signed_url, "_blank");
    } else {
      throw new Error("Failed to generate signed URL");
    }
  } catch (error) {
    console.error("viewFileInNewTab Error - ", error);
    throw error;
  }
};

/**
 * Helper function to download file using signed URL
 * @param {string} token - Authentication token
 * @param {string} fileUrl - S3 file URL
 * @param {string} fileName - Optional custom filename for download
 * @param {number} expiresIn - Expiration time in seconds
 */
export const downloadFileWithSignedUrl = async (
  token,
  fileUrl,
  fileName = null,
  expiresIn = 3600
) => {
  try {
    const response = await generateSignedUrlWithDisposition(
      token,
      fileUrl,
      "attachment",
      expiresIn
    );

    if (response.status === "success" && response.data.signed_url) {
      // Create temporary link and trigger download
      const link = document.createElement("a");
      link.href = response.data.signed_url;

      if (fileName) {
        link.download = fileName;
      } else {
        // Extract filename from URL
        const urlParts = fileUrl.split("/");
        link.download = urlParts[urlParts.length - 1];
      }

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      throw new Error("Failed to generate signed URL");
    }
  } catch (error) {
    console.error("downloadFileWithSignedUrl Error - ", error);
    throw error;
  }
};


// ================= ADMIN DISTRICT SPECIAL GRAM SABHA REPORT =================
export const getAdminDistrictSpecialGsReport = async (token, period = null) => {
  try {
    console.log("Calling admin district report API");

    const response = await axios.get("/admin/report/district-summary", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      params: period ? { period } : {},
    });

    console.log("API Response:", response.data);

    if (!response.data.success) {
      throw new Error(response.data.message || "Failed to fetch admin report");
    }

    return response.data;  // Return the full response object

  } catch (error) {
    console.error("Admin District Report Error - ", error);

    // Provide more detailed error information
    const errorMessage = error.response?.data?.message ||
      error.message ||
      "Failed to fetch admin district report";

    throw new Error(errorMessage);
  }
};


// ================= DISTRICT SPECIAL GRAM SABHA REPORT =================
export const getCeoDistrictSpecialGsReport = async (token, period = null) => {

  const user_id = sessionStorage.getItem("user_id");

  if (!user_id) {
    throw new Error("User ID not found in sessionStorage");
  }

  const response = await axios.get("/get_ceo_district_report", {
    headers: { Authorization: `Bearer ${token}` },
    params: { user_id, ...(period && { period }) }
  });

  return response.data;
};
// ================= BLOCK SPECIAL GRAM SABHA REPORT =================
// In User.js - Update API function to use correct route
// In src/api/User.js
export const getBdpoBlockSpecialGsReport = async (token, period = null) => {
  try {
    console.log("Calling BDPO Block Special Report API...");

    // Get user_id from sessionStorage
    const user_id = sessionStorage.getItem("user_id");

    if (!user_id) {
      throw new Error("User ID not found in sessionStorage");
    }

    const response = await axios.get("/get_bdpo_block_report-bdpos", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      params: {
        user_id,
        ...(period && { period })
      } // Add user_id and period as query parameter
    });

    console.log("Block Report Response:", response.data);

    // Check if API call was successful
    if (!response.data.success) {
      throw new Error(response.data.message || "Failed to fetch block report");
    }

    return response.data; // Return full response

  } catch (error) {
    console.error("BDPO Block Report Error - ", error);

    // Provide detailed error information
    const errorMessage = error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Failed to fetch admin block report";

    throw new Error(errorMessage);
  }
};

export const getPanchayatSpecialGsReport = async (token, filters = {}) => {
  try {
    console.log("Calling BDPO Panchayat Report API...");

    // Get user_id from sessionStorage
    const user_id = sessionStorage.getItem("user_id");

    if (!user_id) {
      throw new Error("User ID not found in sessionStorage");
    }

    const response = await axios.get("/get_panchayat_report-bdpo", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      params: {
        user_id,
        ...filters // Spread filters to include period if provided
      }
    });

    console.log("BDPO Panchayat Report Response:", response.data);

    // Check if API call was successful (note: this API uses 'status' not 'success')
    if (response.data.status !== 'success') {
      throw new Error(response.data.message || "Failed to fetch panchayat report");
    }

    return response.data; // Return full response

  } catch (error) {
    console.error("BDPO Block Report Error - ", error);

    // Provide detailed error information
    const errorMessage = error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Failed to fetch admin block report";

    throw new Error(errorMessage);
  }
};




export const getBlocksummaryforadmin = async (token, district_code) => {
  try {
    console.log(`Calling Block Summary Report API for district: ${district_code}`);

    const response = await axios.get("/admin/report/block-summary", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      params: {
        district_code: district_code  // Add district_code parameter
      }
    });

    console.log("Block Summary Report Response:", response.data);

    if (!response.data.success) {
      throw new Error(response.data.message || "Failed to fetch block summary report");
    }

    return response.data;

  } catch (error) {
    console.error("Block Summary Report Error:", error);

    const errorMessage = error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Failed to fetch block summary report";

    throw new Error(errorMessage);
  }
};

export const getAdminGpSummaryReport = async (token, district_code, block_code = null, filters = {}) => {
  try {
    console.log(`Calling GP Summary Report API for district: ${district_code}, block: ${block_code || 'all'}`);

    // Prepare params object
    const params = {
      district_code: district_code,
      ...filters // Spread filters to include period if provided
    };

    // Add block_code only if provided
    if (block_code) {
      params.block_code = block_code;
    }

    const response = await axios.get("/admin/report/gp-summary", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      params: params
    });

    console.log("GP Summary Report Response:", response.data);

    if (!response.data.success) {
      throw new Error(response.data.message || "Failed to fetch GP summary report");
    }

    return response.data;

  } catch (error) {
    console.error("GP Summary Report Error:", error);

    const errorMessage = error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Failed to fetch GP summary report";

    throw new Error(errorMessage);
  }
};

export const getDistrictwiseGSCompliance = async (token, period = null) => {
  try {
    console.log("Calling Districtwise GS Compliance Report API...");

    const response = await axios.get(
      "/admin/report/districtwise-gs-compliance",   // ✅ CORRECT PATH
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        params: period ? { period } : {},
      }
    );

    console.log("Districtwise GS Compliance Response:", response.data);

    if (!response.data.success) {
      throw new Error(
        response.data.message || "Failed to fetch districtwise GS compliance report"
      );
    }

    return response.data;

  } catch (error) {
    console.error("Districtwise GS Compliance Error:", error);

    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Failed to fetch districtwise GS compliance report";

    throw new Error(errorMessage);
  }
};

export const getCeoDistrictwiseGSCompliance = async (token, period = null) => {

  const user_id = sessionStorage.getItem("user_id");

  if (!user_id) {
    throw new Error("User ID not found in sessionStorage");
  }

  const response = await axios.get(
    "/ceo/report/districtwise-gs-compliance",
    {
      headers: { Authorization: `Bearer ${token}` },
      params: { user_id, ...(period && { period }) }
    }
  );

  return response.data;
};



export const getBDPODistrictwiseGSCompliance = async (token, period = null) => {
  try {
    // Get user_id from sessionStorage
    const user_id = sessionStorage.getItem("user_id");

    if (!user_id) {
      throw {
        success: false,
        message: "User ID not found. Please login again."
      };
    }

    console.log(`Fetching BDPO Districtwise GS Compliance for user: ${user_id}`);

    // Make API call
    const response = await axios.get(
      "/bdpo/report/districtwise-gs-compliance",
      {
        params: { user_id, ...(period && { period }) },
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );

    // Log successful response
    if (response.data.success) {
      console.log(`Successfully fetched ${response.data.result?.length || 0} blocks`);
    }

    return response.data;

  } catch (error) {
    console.error("getBDPODistrictwiseGSCompliance Error:", error);

    // Detailed error handling
    let errorMessage = "Failed to fetch BDPO Districtwise GS Compliance report";

    if (error.response) {
      // Server responded with error status
      const serverError = error.response.data;
      console.error("Server Error Response:", serverError);

      errorMessage = serverError.message ||
        serverError.error ||
        `Server Error: ${error.response.status}`;

      throw {
        success: false,
        message: errorMessage,
        error: serverError,
        statusCode: error.response.status
      };

    } else if (error.request) {
      // Request was made but no response received
      console.error("No response received from server:", error.request);
      throw {
        success: false,
        message: "No response from server. Please check your network connection."
      };

    } else {
      // Something else happened while setting up the request
      console.error("Request setup error:", error.message);
      throw {
        success: false,
        message: error.message || errorMessage
      };
    }
  }
};

export const getPanchayatGSCompliance = async (token, period = null) => {
  try {
    // Get user_id from sessionStorage
    const user_id = sessionStorage.getItem("user_id");

    if (!user_id) {
      throw {
        success: false,
        message: "User ID not found. Please login again."
      };
    }

    console.log(`Fetching BDPO Districtwise GS Compliance for user: ${user_id}`);

    // Make API call
    const response = await axios.get(
      "/bdpo/report/panchayat-gs-compliance",
      {
        params: { user_id, ...(period && { period }) },
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );

    // Log successful response
    if (response.data.success) {
      console.log(`Successfully fetched ${response.data.result?.length || 0} blocks`);
    }

    return response.data;

  } catch (error) {
    console.error("getBDPODistrictwiseGSCompliance Error:", error);

    // Detailed error handling
    let errorMessage = "Failed to fetch BDPO Districtwise GS Compliance report";

    if (error.response) {
      // Server responded with error status
      const serverError = error.response.data;
      console.error("Server Error Response:", serverError);

      errorMessage = serverError.message ||
        serverError.error ||
        `Server Error: ${error.response.status}`;

      throw {
        success: false,
        message: errorMessage,
        error: serverError,
        statusCode: error.response.status
      };

    } else if (error.request) {
      // Request was made but no response received
      console.error("No response received from server:", error.request);
      throw {
        success: false,
        message: "No response from server. Please check your network connection."
      };

    } else {
      // Something else happened while setting up the request
      console.error("Request setup error:", error.message);
      throw {
        success: false,
        message: error.message || errorMessage
      };
    }
  }
};

// Block-level compliance API (to be implemented in backend)
export const getBlockwiseGSCompliance = async (token, district_code) => {
  try {
    console.log(`Calling Block-wise GS Compliance API for district: ${district_code}`);

    const response = await axios.get(
      "/admin/report/blockwise-gs-compliance",
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        params: {
          district_code: district_code
        }
      }
    );

    console.log("Block-wise GS Compliance Response:", response.data);

    if (!response.data.success) {
      throw new Error(
        response.data.message || "Failed to fetch block-wise GS compliance report"
      );
    }

    return response.data;

  } catch (error) {
    console.error("Block-wise GS Compliance Error:", error);

    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Failed to fetch block-wise GS compliance report";

    throw new Error(errorMessage);
  }
};

// GP-level compliance API (to be implemented in backend)
export const getGPwiseGSCompliance = async (token, district_code, block_code = null) => {
  try {
    console.log(`Calling GP-wise GS Compliance API for district: ${district_code}, block: ${block_code || 'all'}`);

    const response = await axios.get(
      "/admin/report/gpwise-gs-compliance",
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        params: {
          district_code: district_code,
          ...(block_code && { block_code: block_code })
        }
      }
    );

    console.log("GP-wise GS Compliance Response:", response.data);

    if (!response.data.success) {
      throw new Error(
        response.data.message || "Failed to fetch GP-wise GS compliance report"
      );
    }

    return response.data;

  } catch (error) {
    console.error("GP-wise GS Compliance Error:", error);

    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Failed to fetch GP-wise GS compliance report";

    throw new Error(errorMessage);
  }
};



export const getBlockwiseGSComplianceCEO = async (token, district_code) => {
  try {
    console.log(`Calling Block Summary Report API for district: ${district_code}`);

    const response = await axios.get("/ceo/report/blockwise-compliance", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      params: {
        district_code: district_code
      }
    });

    console.log("Block Summary Report Response:", response.data);

    if (!response.data.success) {
      throw new Error(response.data.message || "Failed to fetch block summary report");
    }

    return response.data;

  } catch (error) {
    console.error("Block Summary Report Error:", error);

    const errorMessage = error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Failed to fetch block summary report";

    throw new Error(errorMessage);
  }
};

export const getGPwiseGSComplianceCEO = async (token, district_code, block_code = null) => {
  try {
    console.log(`Calling GP Summary Report API for district: ${district_code}, block: ${block_code || 'all'}`);

    const params = {
      district_code: district_code
    };

    if (block_code) {
      params.block_code = block_code;
    }

    const response = await axios.get("/ceo/report/gpwise-compliance", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      params: params
    });

    console.log("GP Summary Report Response:", response.data);

    if (!response.data.success) {
      throw new Error(response.data.message || "Failed to fetch GP summary report");
    }

    return response.data;

  } catch (error) {
    console.error("GP Summary Report Error:", error);

    const errorMessage = error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Failed to fetch GP summary report";

    throw new Error(errorMessage);
  }
};



// File: api/User.js
export const getGPwiseGSComplianceBDPO = async (token, district_code, block_code = null, period = null) => {
  try {
    console.log(`Calling GP-wise GS Compliance Report API for district: ${district_code}, block: ${block_code || 'all'}`);

    // Prepare params object
    const params = {
      district_code: district_code
    };

    // Add block_code only if provided
    if (block_code) {
      params.block_code = block_code;
    }

    // Add period only if provided
    if (period) {
      params.period = period;
    }

    const response = await axios.get("/bdpo/report/gpwise-compliance", {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      params: params
    });

    console.log("GP-wise GS Compliance Report Response:", response.data);

    if (!response.data.success) {
      throw new Error(response.data.message || "Failed to fetch GP-wise compliance report");
    }

    return response.data;

  } catch (error) {
    console.error("GP-wise GS Compliance Report Error:", error);

    const errorMessage = error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Failed to fetch GP-wise compliance report";

    throw new Error(errorMessage);
  }
};



// ================= WIDOW PENSION OBJECTION REPORT =================
export const getWidowPensionObjectionReport = async (token, filters = {}) => {
  try {
    console.log("Calling Widow Pension Objection Report API with filters:", filters);

    const response = await axios.post(
      "/get_widow_pension_objection_report",
      filters, // district_code, block_code etc
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    console.log("Widow Pension Report Response:", response.data);

    if (!response.data.success) {
      throw new Error(response.data.message || "Failed to fetch Widow Pension report");
    }

    return response.data;

  } catch (error) {
    console.error("Widow Pension Report Error:", error);

    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Failed to fetch Widow Pension report";

    throw new Error(errorMessage);
  }
};


export const getDisabilityPensionObjectionReport = async (token, filters = {}) => {
  try {
    console.log("Calling Disability Pension Objection Report API with filters:", filters);

    const response = await axios.post(
      "/get_disability_pension_objection_report",
      filters, // district_code, block_code etc
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    console.log("Widow Pension Report Response:", response.data);

    if (!response.data.success) {
      throw new Error(response.data.message || "Failed to fetch Widow Pension report");
    }

    return response.data;

  } catch (error) {
    console.error("Widow Pension Report Error:", error);

    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Failed to fetch Widow Pension report";

    throw new Error(errorMessage);
  }
};



export const getDeenDayalLaadoLakshmiObjectionReport = async (token, filters = {}) => {
  try {
    console.log("Calling Deen Dayal Laado Lakshmi Objection Report API with filters:", filters);

    const response = await axios.post(
      "/get_deen_dayal_laado_lakshmi_objection_report",
      filters, // district_code, block_code etc
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    console.log("Widow Pension Report Response:", response.data);

    if (!response.data.success) {
      throw new Error(response.data.message || "Failed to fetch Widow Pension report");
    }

    return response.data;

  } catch (error) {
    console.error("Widow Pension Report Error:", error);

    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Failed to fetch Widow Pension report";

    throw new Error(errorMessage);
  }
};


export const getOldAgeSamanAllowanceReport = async (token, filters = {}) => {
  try {
    console.log("Calling Old Age Saman Allowance Report API with filters:", filters);

    const response = await axios.post(
      "/get_old_age_saman_allowance_report",
      filters, // district_code, block_code etc
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    console.log("Widow Pension Report Response:", response.data);

    if (!response.data.success) {
      throw new Error(response.data.message || "Failed to fetch Widow Pension report");
    }

    return response.data;

  } catch (error) {
    console.error("Widow Pension Report Error:", error);

    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      "Failed to fetch Widow Pension report";

    throw new Error(errorMessage);
  }
};

export const getInspectionMeetings = async (token, data, page = 1, limit = 10) => {
  try {
    const response = await axios.get(`/inspection/meetings`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        ...data,
        page,
        limit,
      },
    });
    return response.data;
  } catch (error) {
    console.error("getInspectionMeetings Error:", error);
    throw error;
  }
};

export const getDrinkingWaterInspection = async (token, meetingId) => {
  try {
    const response = await axios.get(`/inspection/drinking-water/${meetingId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("getDrinkingWaterInspection Error:", error);
    throw error;
  }
};

export const saveDrinkingWaterInspection = async (token, data) => {
  try {
    const response = await axios.post(`/inspection/drinking-water`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("saveDrinkingWaterInspection Error:", error);
    throw error;
  }
};

export const updateDrinkingWaterInspection = async (token, id, data) => {
  try {
    const response = await axios.put(`/inspection/drinking-water/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("updateDrinkingWaterInspection Error:", error);
    throw error;
  }
};

export const getDrugAddictionInspection = async (token, meetingId) => {
  try {
    const response = await axios.get(`/inspection/drug-addiction/${meetingId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("getDrugAddictionInspection Error:", error);
    throw error;
  }
};

export const saveDrugAddictionInspection = async (token, data) => {
  try {
    const response = await axios.post(`/inspection/drug-addiction`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("saveDrugAddictionInspection Error:", error);
    throw error;
  }
};

export const updateDrugAddictionInspection = async (token, id, data) => {
  try {
    const response = await axios.put(`/inspection/drug-addiction/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("updateDrugAddictionInspection Error:", error);
    throw error;
  }
};

export const getCleanlinessInspection = async (token, meetingId) => {
  try {
    const response = await axios.get(`/inspection/cleanliness/${meetingId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("getCleanlinessInspection Error:", error);
    throw error;
  }
};

export const saveCleanlinessInspection = async (token, data) => {
  try {
    const response = await axios.post(`/inspection/cleanliness`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("saveCleanlinessInspection Error:", error);
    throw error;
  }
};

export const updateCleanlinessInspection = async (token, id, data) => {
  try {
    const response = await axios.put(`/inspection/cleanliness/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("updateCleanlinessInspection Error:", error);
    throw error;
  }
};

export const getWastewaterInspection = async (token, meetingId) => {
  try {
    const response = await axios.get(`/inspection/wastewater/${meetingId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("getWastewaterInspection Error:", error);
    throw error;
  }
};

export const saveWastewaterInspection = async (token, data) => {
  try {
    const response = await axios.post(`/inspection/wastewater`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("saveWastewaterInspection Error:", error);
    throw error;
  }
};

export const updateWastewaterInspection = async (token, id, data) => {
  try {
    const response = await axios.put(`/inspection/wastewater/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("updateWastewaterInspection Error:", error);
    throw error;
  }
};

// General Gram Sabha Status Report (Admin - Districtwise)
export const getGeneralGramSabhaStatusAdmin = async (token, payload) => {
  try {
    const response = await axios.post(
      "/reports/general-gram-sabha-status-admin",
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("getGeneralGramSabhaStatusAdmin Error:", error);
    throw error;
  }
};